'use client';

import { Link } from '~/components/Link';

import AppDownloadQrImage from '~/public/assets/images/app_download_qr.svg';
import AppleStore from '~/public/assets/icons/ic_apple.svg';
import GooglePlay from '~/public/assets/icons/ic_google.svg';
import styles from './AppDownloadBXArea.module.css';

/** PC 화면에서 보여줄 BX 영역 (앱 다운로드) */
export const AppDownloadBXArea = () => {
  return (
    <section className={styles.qr}>
      <div className={styles.qrImageContainer}>
        <AppDownloadQrImage width={172} height={172} />
      </div>

      <div>
        <span className={styles.qrTitle}>
          스마트폰에서 더 편리한
          <br />
        </span>
        <span className={styles.qrSubTitle}>번개장터 앱 다운받기</span>
      </div>

      <div className={styles.downloadButtonContainer}>
        <Link href="https://play.google.com/store/apps/details?id=kr.co.quicket" target="_blank">
          <GooglePlay />
        </Link>
        <Link href="https://apps.apple.com/kr/app/%EB%B2%88%EA%B0%9C%EC%9E%A5%ED%84%B0/id395672275" target="_blank">
          <AppleStore />
        </Link>
      </div>
    </section>
  );
};
